import {
  REQUEST_ADVERTISER_WITH_ORDERS,
  RECEIVE_ADVERTISER_WITH_ORDERS,
  ADVERTISER_WITH_ORDERS_FAILED,
  RECEIVE_DELETED_ORDER
} from '../actions/types';

function advertiserRequest(state = {}, action) {
  let deletedOrder;
  let orders;
  switch (action.type) {
    case RECEIVE_ADVERTISER_WITH_ORDERS:
      return Object.assign({}, state, {
        isFetching: false,
        advertiser: action.payload,
        advertiserId: action.payload.id,
        error: null
      });
    case REQUEST_ADVERTISER_WITH_ORDERS:
      return Object.assign({}, state, {
        isFetching: true,
        advertiserId: action.payload.id,
        advertiser: {},
        error: null
      });
    case ADVERTISER_WITH_ORDERS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        advertiserId: null,
        advertiser: null,
        error: action.error
      });
    case RECEIVE_DELETED_ORDER:
      deletedOrder = parseInt(action.payload.deleted, 10);
      orders = state.advertiser.Ios.filter(io => io.id !== deletedOrder);
      return Object.assign({}, state, {
        isFetching: false,
        advertiser: {
          ...state.advertiser,
          Ios: orders
        }
      });
    default: {
      return state;
    }
  }
}

export default advertiserRequest;
